export default function wallets(client, config) {
  const path = `/widgets/${config.widgetUUID}/wallets`;
  return {
    create: (data) => client.request({ endpoint: path, method: "POST", body: data }),
    get: (id) => client.request({ endpoint: `${path}/${id}`, method: "GET" }),
    list: () => client.request({ endpoint: `${path}?ordering=id`, method: "GET" }),
    partialUpdate: (id, data) => client.request({ endpoint: `${path}/${id}`, method: "PATCH", body: data }),
    mobilePayment: (id) => client.request({ endpoint: `${path}/${id}/mobile_payment`, method: "GET" }),
    getBalances: (id, options = {}) => {
      const params = options.onlyActiveCurrencies ? "?only_active_currencies=true" : "";
      return client.request({ endpoint: `${path}/${id}/balances${params}`, method: "GET" });
    },
    getBarcodesInfo: (data) => client.request({
      version: "v2",
      endpoint: `${path}/actions`,
      method: "POST",
      body: {
        type: "CHECK_BARCODES",
        config: data,
      },
    }),
    blockTagActivate: (id, data) => client.request({
      version: "v2",
      endpoint: `${path}/${id}/actions`,
      method: "POST",
      body: {
        type: "BLOCK_TAG",
        config: data,
      },
    }),
    blockTagDeactivate: (id, data) => client.request({
      version: "v2",
      endpoint: `${path}/${id}/actions`,
      method: "POST",
      body: {
        type: "UNBLOCK_TAG",
        config: data,
      },
    }),
    getReusableTags: () => client.request({
      version: "v2",
      endpoint: `${path}/actions`,
      method: "POST",
      body: {
        type: "RETRIEVE_REUSABLE_TAGS",
      },
    }),
  };
}
